import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ROUTES, RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NguiMapModule } from '@ngui/map';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { NgxGeoautocompleteModule } from "ngx-geoautocomplete-v2";
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthGuard } from 'src/lib/core/authentication/auth.guard';
import { PipesModule } from '../../theme/pipes/pipes.module';
import { ConnoteDetailsComponent } from '../bookings/connotedetails/connotedetails.component';
import { DispatchplannerComponent } from './dispatchplanner/dispatchplanner.component';
import { ManifestlistComponent } from './manifestlist/manifestlist.component';
import { ManifestEventsComponent } from './manifestevents/manifestevents.component';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxDaterangepickerMd, DaterangepickerComponent } from 'ngx-daterangepicker-material';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { LocalDispatchComponent } from './local-dispatch/local-dispatch.component';
import { LocalManifestComponent } from './local-manifest/local-manifest.component';
import { FileUploaderModule } from '../../pages/control/file-uploader/file-uploader.module';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { ManifestdetailsModule } from './manifestdetails/manifestdetails.module';
import { LocalManifestv2Component } from './local-manifestv2/local-manifestv2.component';
import { Manifestlistv2Component } from './manifestlistv2/manifestlistv2.component';

import { ComponentsSettingsService } from '../../services/components_settings.service';
import { LocalStorage, LocalStorageService } from 'ngx-store';

// export const routes: Routes = [
//     { path: '', redirectTo: 'manifestlist', pathMatch: 'full'},
//     { path: 'manifestlist', component: ManifestlistComponent, data: { breadcrumb: 'Dispatch List' } },
//     { path: 'local-dispatch', component: LocalDispatchComponent, data: { breadcrumb: 'Local Dispatch' } },
//     { path: 'local-manifest', component: LocalManifestComponent, data: { breadcrumb: 'Local Manifest' } },

//     { path: 'dispatchplanner', component: DispatchplannerComponent, data: { breadcrumb: 'Linehaul Dispatch' } },
    
//     { path: 'bookings/connotes/details/:id', component: ConnoteDetailsComponent, data: { breadcrumb: 'Connote Details' } },
//     {
//         path: 'editor',
//         loadChildren: () => import('./run/editor/editor.module').then(m => m.RunEditorModule),
//         data: { breadcrumb: 'Dispatch Editor' },
//         canActivate: [AuthGuard]
//     },
//     { path: 'manifestevents/:id', component: ManifestEventsComponent, data: { breadcrumb: 'Manifest Actual Events' } },

    // { path: 'local-manifestv2', component: LocalManifestv2Component, data: { breadcrumb: 'Local Manifestv2' } },
    // { path: 'manifestlistv2', component: Manifestlistv2Component, data: { breadcrumb: 'Dispatch Listv2' } },

// ];

let google_map_api_nicola = localStorage.getItem('ngx_google_map_api_nicola') || '';

@NgModule({
    imports: [
        SharedModule,
        RouterModule,
        //RouterModule.forChild(routes),
        DragulaModule,
        NgxDatatableModule,
        FormsModule,
        NgbModule,
        PipesModule,
        NgxPaginationModule,
        ReactiveFormsModule,
        MyDatePickerModule,
        FileUploaderModule,
        NgxDaterangepickerMd.forRoot(),
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.threeBounce,
            backdropBackgroundColour: 'rgba(0, 0, 0, 0)',
            backdropBorderRadius: '4px',
            primaryColour: '#666666',
            secondaryColour: '#666666',
            tertiaryColour: '#666666'
          }),
        NgxGeoautocompleteModule.forRoot(),
        NguiMapModule.forRoot({apiUrl: `https://maps.google.com/maps/api/js?key=${google_map_api_nicola}`}),
        PerfectScrollbarModule,
        MultiselectDropdownModule,
        ManifestdetailsModule
    ],
    declarations: [
        DispatchplannerComponent,
        ManifestlistComponent,
        ManifestEventsComponent,
        LocalDispatchComponent,
        LocalManifestComponent,
        LocalManifestv2Component,
        Manifestlistv2Component
    ],
    providers: [DragulaService,
        {
          provide: ROUTES,
          useFactory: (svc_component_settings : ComponentsSettingsService, svc_local_storage: LocalStorageService): Routes => {
            let routes: Routes = [];
            let tms_components = svc_local_storage.get('components');
            
            var connote = 0;
            var editor = 0;
            
            if(tms_components){
              tms_components.forEach(item=>{

                if((connote == 0) && item== 'Linehaul Dispatch' || item== 'Local Dispatch' || item== 'Local Manifest' || item== 'Linehaul Manifest'){
                  connote +=1;
                  routes.push( { path: 'bookings/connotes/details/:id', component: ConnoteDetailsComponent, data: { breadcrumb: 'Connote Details' } });
                }

                switch(item){
                  case 'Linehaul Dispatch': 
                  case 'Local Dispatch':{ 
                    if(item =='Local Dispatch'){
                      routes.push( { path: 'local-dispatch', component: LocalDispatchComponent, data: { breadcrumb: 'Local Dispatch' } });
                    }
                    if(item =='Linehaul Dispatch'){
                      routes.push({ path: 'dispatchplanner', component: DispatchplannerComponent, data: { breadcrumb: 'Linehaul Dispatch' } });
                    }
                    break
                  };
                  
                  case 'Local Manifest' :
                  case 'Linehaul Manifest' :{
                    
                    if(editor == 0){
                      editor +=1;
                      routes.push({path: 'editor',loadChildren: () => import('./run/editor/editor.module').then(m => m.RunEditorModule),data: { breadcrumb: 'Dispatch Editor' },canActivate: [AuthGuard]});
                    };

                    if(item == 'Local Manifest'){ 
                      routes.push( { path: 'local-manifest', component: LocalManifestComponent, data: { breadcrumb: 'Local Manifest' } });
                      routes.push( { path: 'local-manifestv2', component: LocalManifestv2Component, data: { breadcrumb: 'Local Manifestv2' } });
                      routes.push();
                    };

                    if(item == 'Linehaul Manifest'){ 
                      routes.push({ path: '', redirectTo: 'manifestlist', pathMatch: 'full'});
                      routes.push({ path: 'manifestlist', component: ManifestlistComponent, data: { breadcrumb: 'Dispatch List' } });
                      routes.push({ path: 'manifestlistv2', component: Manifestlistv2Component, data: { breadcrumb: 'Dispatch Listv2' } });
                    }
                    break;
                  }
                };
                
              });
            }
           
            return [...routes];
          },
          deps: [ComponentsSettingsService, LocalStorageService],
          multi: true
        }
    ],
    entryComponents: [DaterangepickerComponent],
    exports: [RouterModule]
})

export class DispatchModule { }